import { useDispatch } from 'react-redux';
import { map } from 'rxjs/operators';

import { getListById } from 'app/actions/ListActions';

const useListApi = () => {
  const dispatch = useDispatch();

  const fetchList = (listId, subdomain) => {
    return dispatch((_dispatch, getState, apiClient) => {
      return getListById({ itemsPerPageLimit: 1, listId, subdomain })
        .apiRequest(getState(), apiClient)
        .pipe(
          map(response => {
            return response.body;
          })
        )
        .toPromise()
        .then(response => {
          return response.list;
        });
    });
  };

  return {
    fetchList
  };
};

export default useListApi;
